import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { LawPersonFormGroup, PortalId } from '@gk/gk-modules';
import {
  BaseNewRequestControlName,
  LawPersonNewRequestFormGroup,
} from '../../../../shared/base-new-request-form/base-new-request-form.model';
import { GRPPortalDocument } from '../portals/portals.model';

export const SourcePortalIdQueryParam = 'sourcePortalId';

export enum GRPNewGrantRequestAdditionalControlName {
  Permission = 'permission',
  PortalIds = 'portalIds',
}

export enum GRPPermissionControlName {
  PortalName = 'portalName',
  PortalId = 'portalId',
  PermissionNumber = 'permissionNumber',
  Documents = 'documents',
  IsPermissionNumberRequired = 'isPermissionNumberRequired',
  Entity = 'entity',
  LegalBasis = 'legalBasis',
  TermsAndConditionsAcceptance = 'termsAndConditionsAcceptance',
  IsTermsAndConditionsFileAvailable = 'isTermsAndConditionsFileAvailable',
}

export const GRPNewGrantRequestControlName = {
  ...BaseNewRequestControlName,
  ...GRPNewGrantRequestAdditionalControlName,
};

export interface GRPPermissionFormGroup {
  [GRPPermissionControlName.PortalName]: FormControl<string>;
  [GRPPermissionControlName.PortalId]: FormControl<PortalId>;
  [GRPPermissionControlName.PermissionNumber]: FormControl<string>;
  [GRPPermissionControlName.Documents]: FormControl<
    GRPPortalDocument[] | undefined
  >;
  [GRPPermissionControlName.IsPermissionNumberRequired]: FormControl<boolean>;
  [GRPPermissionControlName.Entity]: FormGroup<LawPersonFormGroup>;
  [GRPPermissionControlName.LegalBasis]: FormControl<string>;
  [GRPPermissionControlName.TermsAndConditionsAcceptance]: FormControl<boolean>;
  [GRPPermissionControlName.IsTermsAndConditionsFileAvailable]: FormControl<boolean>;
}

export interface GRPNewGrantRequestFormGroup
  extends LawPersonNewRequestFormGroup {
  [GRPNewGrantRequestControlName.PortalIds]: FormControl<PortalId[]>;
  [GRPNewGrantRequestControlName.Permission]: FormArray<
    FormGroup<GRPPermissionFormGroup>
  >;
}
